import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { withNamespaces } from 'react-i18next';
import { BACKEND_URL } from '../../../services/backendURL';
import { Row, Col } from 'antd';
import { DownOutlined } from "@ant-design/icons";



const ProfileMenu = (props) => {
    const name = useSelector((state) => state.Member.name);
    const surname = useSelector((state) => state.Member.surname);
    const photo = useSelector((state) => state.Member.member_data?.photo);
    const [menu, setMenu] = useState(false);
    let history = useHistory();

    const toggle = () => {
        setMenu(prevState => !prevState);
    }

    const goToProfile = () => {
        history.push("/profile");
    }

    const username = name + ' ' + surname;
    const photoUrl = BACKEND_URL + photo;

    return (
        <React.Fragment>
            <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block" >
                <DropdownToggle className="btn header-item waves-effect" id="page-header-user-dropdown" tag="button">
                    <Row gutter={24} align="middle" className='m-0'>
                        <Col span={5} className='mt-1'>
                            {
                                !photo ?
                                    <div className="avatar-xs">
                                        <span className="avatar-title rounded-circle">
                                            {username.charAt(0)}
                                        </span>
                                    </div>
                                    :
                                    <img className="rounded-circle header-profile-user" src={photoUrl} alt="Avatar" />
                            }
                        </Col>
                        <Col span={16} className='text-left'>
                            <span className="d-none d-xl-inline-block mr-1 mt-1" style={{ fontSize: "15px" }}>{username}</span>
                            <span className='text-muted mt-1'></span>
                        </Col>
                        <Col span={2} className='text-right'>
                            <DownOutlined />
                        </Col>
                    </Row>
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem tag="a" onClick={() => goToProfile()}>
                        <i className="bx bx-user font-size-16 align-middle mr-1"></i>
                        {props.t('Profile')}
                    </DropdownItem>

                    <div className="dropdown-divider"></div>

                    <Link to="logout" className="dropdown-item">
                        <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                        <span>{props.t('Logout')}</span>
                    </Link>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
}


export default withRouter(withNamespaces()(ProfileMenu));